<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.35917 9.75098H5.69946V11.4107H7.35917V9.75098Z" fill="#153D49" />
    <path d="M7.35917 3.1123H5.69946V4.77201H7.35917V3.1123Z" fill="#153D49" />
    <path d="M7.35917 6.43164H5.69946V8.09135H7.35917V6.43164Z" fill="#153D49" />
    <path d="M10.6785 3.1123H9.0188V4.77201H10.6785V3.1123Z" fill="#153D49" />
    <path d="M10.6785 6.43164H9.0188V8.09135H10.6785V6.43164Z" fill="#153D49" />
    <path
      d="M13.1681 11.7314C12.3673 11.7314 11.7158 12.3829 11.7158 13.1837C11.7158 13.9845 12.3673 14.6359 13.1681 14.6359C13.9688 14.6359 14.6203 13.9845 14.6203 13.1837C14.6203 12.3829 13.9688 11.7314 13.1681 11.7314Z"
      fill="#153D49"
    />
    <path
      d="M13.7904 8.9848V0H2.5874V18.4643H11.9465L13.1681 20L16.4986 15.8127C17.0966 15.0565 17.4127 14.1473 17.4127 13.1836C17.4127 11.0546 15.8369 9.28678 13.7904 8.9848ZM3.83218 17.2195V1.24478H12.5457V8.9848C10.4992 9.28682 8.92343 11.0546 8.92343 13.1837C8.92343 14.1474 9.23956 15.0566 9.83868 15.8141L10.9565 17.2195H3.83218ZM15.5232 15.0393L13.168 18.0003L10.814 15.0406C10.3915 14.5064 10.1682 13.8643 10.1682 13.1837C10.1682 11.5296 11.5139 10.1839 13.1681 10.1839C14.8222 10.1839 16.1679 11.5296 16.1679 13.1837C16.1679 13.8643 15.9446 14.5064 15.5232 15.0393Z"
      fill="#153D49"
    />
  </svg>
</template>
